module.exports = __webpack_public_path__ + "img/small_text.4bd527c4.png";